import { useQuery } from "@tanstack/react-query"
import { apiFetchWeb } from "./apiFetchWeb"

export interface WebsiteConfigData {
  title: string
  description: string
  logo_image: string
  banner_image: string
  [key: string]: any
}

export const useWebsiteConfig = () => {
  return useQuery({
    queryKey: ["website-config"],
    queryFn: async () => {
      const response = await apiFetchWeb<WebsiteConfigData>("settings/website-details", {
        method: "GET",
      })
      return response
    }
  })
}
